import * as stylex from '@stylexjs/stylex';
import { SiteFooter } from '~components/SiteFooter';
import { styles } from './styles';
import type { LegalDoc } from './types';

// One shell for every legal document. Sections carry their own anchor ids so the
// contents list, in-app deep links, and any regulator citation all point at a
// stable fragment.
export function Legal({
  doc
}: {
  doc: LegalDoc;
}) {
  return <>
      <main lang={doc.lang} {...stylex.props(styles.container)}>
      <h1 {...stylex.props(styles.title)}>{doc.title}</h1>
      <p {...stylex.props(styles.meta)}>
        <span>{doc.updatedLabel}</span>
        <a href={doc.altHref} {...stylex.props(styles.altLink)}>{doc.altLabel}</a>
      </p>

      <nav {...stylex.props(styles.contents)} aria-label={doc.contentsLabel}>
        <p {...stylex.props(styles.contentsHeading)}>{doc.contentsLabel}</p>
        <ol {...stylex.props(styles.contentsList)}>
          {doc.sections.map(s => <li key={s.id}>
              <a href={`#${s.id}`} {...stylex.props(styles.link)}>{s.heading}</a>
            </li>)}
        </ol>
      </nav>

      {doc.sections.map(s => <section key={s.id} id={s.id} {...stylex.props(styles.section)}>
          <h2 {...stylex.props(styles.heading)}>{s.heading}</h2>
          {s.body}
        </section>)}
      </main>
      <SiteFooter lang={doc.lang} />
    </>;
}